import React, { memo } from 'react';

function LogOut() {
  return <>img</>;
}

export default memo(LogOut);
